"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default(props) {
  var form = props.form,
    field = props.field,
    options = props.options,
    questSettings = props.questSettings,
    showHeader = props.showHeader,
    showFooter = props.showFooter,
    settingsFieldName = props.settingsFieldName,
    _props$width = props.width,
    width = _props$width === void 0 ? '140px' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '112px' : _props$height,
    _props$isScrollView = props.isScrollView,
    isScrollView = _props$isScrollView === void 0 ? true : _props$isScrollView;
  var currentOption = options.find(function (option) {
    return field.value === option.handle;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames3["default"])(_style["default"].frameWrapper, _defineProperty({}, _style["default"].scrollView, isScrollView))
  }, options.map(function (option) {
    var item = /*#__PURE__*/_react["default"].createElement("label", {
      key: option.handle,
      className: (0, _classnames3["default"])(_style["default"].frame, _defineProperty({}, _style["default"].selected, field.value === option.handle))
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, field, {
      checked: field.value === option.handle,
      value: option.handle,
      type: "radio"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].thumbnail,
      style: {
        width: width,
        height: height
      }
    }, typeof option.thumbnail === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].image,
      style: {
        backgroundImage: "url(".concat(option.thumbnail, ")")
      }
    }) : option.thumbnail(_objectSpread({}, field.value === option.handle && {
      settings: (0, _get2["default"])(form.values, settingsFieldName)
    })), showHeader && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].header
    }), showFooter && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].footer
    })), option.label && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].label
    }, option.label));
    return option.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: option.tooltip,
      key: option.handle
    }, item) : item;
  }))), currentOption && currentOption.settingsComponent && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '1.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(currentOption.settingsComponent, {
    settingsFieldName: settingsFieldName,
    questSettings: questSettings || form.values
  })));
};